import { LoginPageComponent } from './login-page/login-page.component';
import { RecoverPasswordPageComponent } from './recover-password-page/recover-password-page.component';
import { RecoverPasswordSentPageComponent } from './recover-password-sent-page/recover-password-sent-page.component';
import { SetPasswordPageComponent } from './reset-password-page/set-password-page.component';

export * from './recover-password-page/recover-password-page.component';
export * from './login-page/login-page.component';
export * from './recover-password-sent-page/recover-password-sent-page.component';
export * from './reset-password-page/set-password-page.component';

export const authPages = [
    LoginPageComponent,
    RecoverPasswordPageComponent,
    RecoverPasswordSentPageComponent,
    SetPasswordPageComponent,
];
